"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const queries_1 = require("./queries");
class AuthClient {
    constructor(graphQLClient, credentialStorage) {
        this.graphQLClient = graphQLClient;
        this.credentialStorage = credentialStorage;
        this.credentials_ = null;
    }
    get credentials() {
        return this.credentials_;
    }
    setCredentials(value) {
        return __awaiter(this, void 0, void 0, function* () {
            this.credentials_ = value;
            yield this.credentialStorage.setCredentials(value);
        });
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.credentials_ = yield this.credentialStorage.getCredentials();
        });
    }
    isAuthorized() {
        return Boolean(this.credentials);
    }
    isCredentialsValidOrUndefined() {
        return !this.credentials || this.credentials.expiresAt > Date.now();
    }
    login(login, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.graphQLClient.executeRequest(queries_1.MUTATION_LOGIN, {
                login,
                password,
            });
            const loginResponse = response.auth.login;
            yield this.setCredentials({
                idToken: loginResponse.idToken,
                refreshToken: loginResponse.refreshToken,
                expiresAt: loginResponse.expiresIn * 1000 + Date.now(),
            });
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            this.credentials_ = null;
            yield this.credentialStorage.clearCredentials();
        });
    }
    tryToRefreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.credentials) {
                return;
            }
            if (this.credentials.expiresAt > Date.now()) {
                return;
            }
            yield this.refresh();
        });
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.credentials) {
                throw new Error('Not authorized');
            }
            const response = yield this.graphQLClient.executeRequest(queries_1.MUTATION_REFRESH_TOKEN, {
                refreshToken: this.credentials.refreshToken,
            });
            const refreshResponse = response.auth.refreshToken;
            yield this.setCredentials({
                refreshToken: refreshResponse.refreshToken,
                idToken: refreshResponse.idToken,
                expiresAt: refreshResponse.expiresIn * 1000 + Date.now(),
            });
        });
    }
}
exports.default = AuthClient;
